import styled from '@emotion/styled';
import { useState } from 'react';

// Components
import InsulationSearchResult from './PIM/Insulation/SearchResult';
import ParocSearchResult from './PIM/Paroc/SearchResult';

// Utilities
import placeholder_url from '../../../../placeholder';

// Styled Components
const InputContainer = styled.div`
  display: inline-block;
  margin-top: 8px;
  position: relative;
  width: 100%;

  input + div {
    > div {
      top: 0;
    }
  }
`;

const SelectedProduct = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding: ${props => props.padding};
  position: relative;
`;

const ProductTitle = styled.span`
  font-size: 16px;
  font-weight: bold;
  line-height: 18px;
  margin-bottom: ${props => props.margin || 0};
  width: 100%;
`;

const ProductInfo = styled.div`
  display: flex;
  margin-bottom: 8px;
  position: relative;
`;

const ProductImage = styled.img`
  display: inline-block;
  flex-shrink: 0;
  height: 88px;
  margin-right: 16px;
  position: relative;
  width: 88px;
`;

const ResultItem = styled.a`
  color: #000000;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  font-size: 12px;
  line-height: 17px;
  padding: 8px 16px;
  text-decoration: none;

  &.linked {
    color: #6d6d6d;
    cursor: not-allowed;
  }

  .product-group {
    font-size: 16px;
    line-height: 18px;
  }
`;

const ProductItem = styled(ResultItem)`
  padding: 0;
`;

const ProductData = ProductItem.withComponent('div');

const searchResultMapping = {
  pim_insulation: InsulationSearchResult,
  pim_paroc: ParocSearchResult,
};

const LinkPIM = ({
  product = null,
  pimSource,
  style,
  ...props
}) => {
  const [selectedProduct, setSelectedProduct] = useState(product);
  const SearchResultComponent = searchResultMapping[pimSource];

  if (selectedProduct) {
    const productImageUrl =
      selectedProduct?.metadata?.connection?.image ||
      selectedProduct?.productImage?.[0]?.key ||
      placeholder_url(88, 88);
    return (
      <SelectedProduct padding={style?.selectedItemPadding}>
        <ProductTitle margin="16px">PIM Product</ProductTitle>
        <ProductInfo>
          <ProductImage src={productImageUrl} />
          <ProductData>
            <SearchResultComponent
              result={selectedProduct?.metadata?.connection || selectedProduct}
              unwrapped
            />
          </ProductData>
        </ProductInfo>
      </SelectedProduct>
    );
  }

  return (
    <InputContainer>
      <UI.Tip noTopMargin>This PDP is not connected to PIM</UI.Tip>
    </InputContainer>
  );
};

LinkPIM.displayName = 'Build.LinkPIM';

export default LinkPIM;
